export const payment_method = [
  {
    name: '1',
    id: 1,
    label: 'Espèce'
  },
  {
    name: '2',
    id: 2,
    label: 'Carte Bancaire'
  },
  {
    name: '3',
    id: 3,
    label: 'Virement'
  },
  {
    id: 4,
    name: '4',
    label: 'Chèque'
  },
  {
    id: 5,
    name: '5',
    label: 'Paypal'
  },
  {
    id: 6,
    name: '6',
    label: 'Prélèvement'
  },
  {
    id: 7,
    name: '7',
    label: "Bon d'achat"
  },
  {
    id: 8,
    name: '8',
    label: 'Remise sur prochaine facture'
  },
  {
    id: 9,
    name: '9',
    label: 'Stripe'
  }
]

export const customerTypes = [
  { id: 1, name: '1', label: 'Entreprise' },
  { id: 2, name: '2', label: 'Particulier' }
]

export const activityTypes = [
  { id: 1, name: '1', label: 'Vente marchandise' },
  { id: 2, name: '2', label: 'Prestation services commerciales/artisanales' },
  { id: 3, name: '3', label: 'Prestation services et activités libérales' }
]

export const activityNames = [
  {
    id: 1,
    name: '1',
    label: "Main d'oeuvre"
  },
  {
    id: 2,
    name: '2',
    label: 'Déplacement'
  },
  {
    id: 3,
    name: '3',
    label: 'Matériel'
  }
]

export const yesNo = [
  {
    id: 0,
    name: '0',
    label: 'Non'
  },
  { id: 1, name: '1', label: 'Oui' }
]

export const dateFormat = [
  {
    id: 1,
    name: 'YY'
  },
  {
    id: 2,
    name: 'YYYY'
  },
  {
    id: 3,
    name: 'YYMM'
  },
  {
    id: 4,
    name: 'YYYYMM'
  }
]

export const paymentConditions = [
  {
    id: 1,
    name: 'Paiement comptant'
  },
  {
    id: 2,
    name: 'Paiement à réception '
  },
  {
    id: 3,
    name: '30 jours suivant réception des marchandises ou réalisation de la prestation de service'
  },
  {
    id: 4,
    name: '60 jours suivant réception des marchandises ou réalisation de la prestation de service'
  },
  {
    id: 5,
    name: '45 jours suivant suivant la fin du mois d’émission de la facture'
  }
]

export const auditType = [
  { name: 'INSERT', label: 'Ajout' },
  { name: 'UPDATE', label: 'Modification' },
  { name: 'DELETE', label: 'Suppression' }
]

export const baseDocument = [
  { name: 'description', label: 'Description', headerStyle: 'theader2', bodyStyle: 'tbodyfill2', bodyStyle2: 'tbody2' },
  { name: 'quantity', label: 'Quantité', headerStyle: 'theader', bodyStyle: 'tbodyfill', bodyStyle2: 'tbody' },
  { name: 'unit_price', label: 'Prix unitaire', headerStyle: 'theader', bodyStyle: 'tbodyfill', bodyStyle2: 'tbody' },
  { name: 'net_amount', label: 'Total', headerStyle: 'theader', bodyStyle: 'tbodyfill', bodyStyle2: 'tbody' }
]

export const emailType = [
  { id: 'inbound', label: 'Entrant' },
  { id: 'outbound', label: 'Sortant' }
]

export const frequency = [
  {
    id: 1,
    name: 'Semaine'
  },
  {
    id: 2,
    name: 'Mois'
  },
  {
    id: 3,
    name: 'Trimestre'
  },
  {
    id: 4,
    name: 'Année'
  }
]

export const ENTITY_LABELS = {
  customers: 'Client',
  supplier: 'Fournisseur',
  invoices: 'Facture',
  interventions: 'Intervention',
  quotes: 'Devis',
  events: 'Événement',
  users: 'Utilisateur',
  incomes: 'Encaissement',
  outcomes: 'Décaissement',
  contracts: 'Contrat',
  priceBooks: 'Tarif',
  roles: 'Rôle',
  credidNotes: 'Avoir',
  tax: 'Cotisation URSSAF',
  emails: 'Email'
}
